import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import PageLoader from "../../../../components/PageLoader";
import Table from "../../../../common/components/table";
import { selectGlobalAgentNetTypesListItems } from "../../../../redux/global-agent-net-types/selector";
import { globalAgentNetTypes } from "../../../../redux/global-agent-net-types/action";




const GlobalAgentNetTypesMappings = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
    const dbnpMappingItems = useSelector(selectGlobalAgentNetTypesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
           { field: 'Name', headerName: 'Name'},
         { field: 'CreatedOnUtc', headerName: 'Created Date', isDateValueFormat: true },
          { field: 'ModifiedOnUtc', headerName: 'Modified Date', isDateValueFormat: true },
      
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(globalAgentNetTypes.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-agent-net-types/list`,entity:'globalAgentNetTypes',jsonData:{
      
            PageNumber: 1,
            PageSize: 100,
            SortField: 'Id',
            SortOrder: 'desc',
          
      
          }}))
      }
      const handleReloadData = () => {
        dispatch(globalAgentNetTypes.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-agent-net-types/list`,entity:'globalAgentNetTypes',jsonData:{
      
        
            PageNumber: 1,
            PageSize: 100,
            SortField: 'Id',
            SortOrder: 'desc',
          
      
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];
      const fetchDbnpMapping=()=>{

        dispatch(globalAgentNetTypes.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-agent-net-types/list`,entity:'globalAgentNetTypes',jsonData:{
        
            PageNumber: 1,
            PageSize: 100,
            SortField: 'Id',
            SortOrder: 'desc',
      
      
      }}))
       
      }
      const handleDelete=(data: any)=>{
        dispatch(globalAgentNetTypes.delete({
          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-agent-net-types/delete`,
          entity: 'globalAgentNetTypes',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(globalAgentNetTypes.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-agent-net-types/list`,entity:'globalAgentNetTypes',jsonData:{
         
            PageNumber: 1,
            PageSize: 100,
            SortField: 'Id',
            SortOrder: 'desc',
        
      
      }}))
      });
      }
      // const handleEdit=(data: any)=>{
    
      //   navigate(`${data?.Id}`)
      // }
      // const handleAdd=()=>{
      //   navigate(`${0}`)
      // }
	useEffect(() => {
        createColumnDefs()
        fetchDbnpMapping()
		
	}, [pageData,pageSize])
  // const additionButtons: any = [
  //   // {
  //   //   name: 'Add DBNP Mappings',
  //   //   callback: () => handleAdd(),
  //   // }
  // ];
	return (
     <>
     {dbnpMappingItems?.isLoading ? 
      <PageLoader />
  : 
     <Table enableFilter={true}additionButtons={additionButtons}
     filterTypeLists={filterTypes}
     onSearch={handleSearch} columnData={columnDefs} rowData={dbnpMappingItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
     paginationData={dbnpMappingItems?.result?.pagination} headingName="Global AgentNet Types" />
}
     </>
		
       
     
	);
};

export default GlobalAgentNetTypesMappings;


